import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const ShopContext = createContext(null);

const load = (key, fallback) => {
  try {
    return JSON.parse(localStorage.getItem(key)) ?? fallback;
  } catch {
    return fallback;
  }
};

export const ShopProvider = ({ children }) => {
  const [cart, setCart] = useState(() => load("anm_cart", []));
  const [favorites, setFavorites] = useState(() => load("anm_favorites", []));
  const [compare, setCompare] = useState(() => load("anm_compare", []));

  useEffect(() => localStorage.setItem("anm_cart", JSON.stringify(cart)), [cart]);
  useEffect(() => localStorage.setItem("anm_favorites", JSON.stringify(favorites)), [favorites]);
  useEffect(() => localStorage.setItem("anm_compare", JSON.stringify(compare)), [compare]);

  const addToCart = (perfume, size = "50", qty = 1) => {
    setCart((prev) => {
      const idx = prev.findIndex((i) => i.id === perfume.id && i.size === size);
      if (idx >= 0) {
        const next = [...prev];
        next[idx] = { ...next[idx], qty: next[idx].qty + qty };
        return next;
      }
      return [
        ...prev,
        { id: perfume.id, name: perfume.name, brand: perfume.brand, image: perfume.image, size, qty, price: perfume.prices[size] },
      ];
    });
    toast.success(`${perfume.name} (${size} ml) ajouté au panier`);
  };

  const updateQty = (id, size, qty) =>
    setCart((prev) =>
      qty <= 0
        ? prev.filter((i) => !(i.id === id && i.size === size))
        : prev.map((i) => (i.id === id && i.size === size ? { ...i, qty } : i))
    );

  const removeFromCart = (id, size) => setCart((prev) => prev.filter((i) => !(i.id === id && i.size === size)));
  const clearCart = () => setCart([]);

  const cartCount = cart.reduce((s, i) => s + i.qty, 0);
  const cartTotal = cart.reduce((s, i) => s + i.qty * i.price, 0);

  const toggleFavorite = (id) =>
    setFavorites((prev) => (prev.includes(id) ? prev.filter((f) => f !== id) : [...prev, id]));

  const toggleCompare = (id) =>
    setCompare((prev) => {
      if (prev.includes(id)) return prev.filter((c) => c !== id);
      if (prev.length >= 3) {
        toast.error("Vous pouvez comparer 3 parfums maximum");
        return prev;
      }
      toast.success("Ajouté au comparateur");
      return [...prev, id];
    });

  return (
    <ShopContext.Provider
      value={{ cart, addToCart, updateQty, removeFromCart, clearCart, cartCount, cartTotal, favorites, toggleFavorite, compare, toggleCompare }}
    >
      {children}
    </ShopContext.Provider>
  );
};

export const useShop = () => useContext(ShopContext);
